import { Fragment, useContext, useEffect, useState } from 'react'
import { GlobalContext } from 'App'
import Header from 'components/Header/Header'
import './style.css'
import { FullpageContainer, FullpageSection } from '@shinyongjun/react-fullpage'
import '@shinyongjun/react-fullpage/css'
import Lottie from 'react-lottie'
import { experienceData } from 'data/experience'
import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';

const Experience = () => {
  const { isTablet } = useContext(GlobalContext)
  const [activeIndex, setActiveIndex] = useState<number>(0)
  const [endAni, setEndAni] = useState<boolean>(false);

  useEffect(() => {
    setEndAni(false)
  }, [activeIndex])
  return (
    <>
      <Header isOverLay={true} />
      <section className='select-none'>
        <FullpageContainer
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}>
          {
            experienceData.map((item, idx) => (
              <FullpageSection key={idx}>
                {
                  activeIndex === item.id &&
                  <Fragment>
                    <Lottie
                      options={{
                        loop: false,
                        autoplay: true,
                        animationData: isTablet ? item.backgroundMo : item.background,
                        rendererSettings: {
                          preserveAspectRatio: 'xMidYMid slice'
                        }
                      }}
                      isClickToPauseDisabled
                      style={{ cursor: 'default', zIndex: -1, position: 'absolute', left: '50%', maxWidth: '2560px', transform: "translateX(-50%)" }}
                      height={'100%'}
                      width={'100%'}
                      eventListeners={[
                        {
                          eventName: 'complete',
                          callback: () => setEndAni(true),
                        },
                      ]}
                    />
                    {
                      endAni &&
                      <div className='flex justify-end items-center tablet:items-end container'>
                        <div>
                          <motion.p
                            className="mb-4 tablet:px-11 font-semibold text-black tablet:text-lg text-2xl"
                            initial={START_ANIMATION_PROPERTY}
                            whileInView={END_ANIMATION_PROPERTY}
                            viewport={VIEWPORT_PROPERTY} >
                            {item.title}
                          </motion.p>

                          <div className='flex flex-col gap-2 mb-10 tablet:mb-4 tablet:px-11'>
                            {
                              isTablet ?
                                <motion.p
                                  className='text-black tablet:text-xs'
                                  key={idx}
                                  transition={{ delay: (0.1 * idx) }}
                                  initial={START_ANIMATION_PROPERTY}
                                  whileInView={END_ANIMATION_PROPERTY}
                                  viewport={VIEWPORT_PROPERTY} >
                                  {item.description.join(' ')}
                                </motion.p> :
                                item.description.map((item, idx) => (
                                  <motion.p
                                    className='text-black tablet:text-xs'
                                    key={idx}
                                    transition={{ delay: (0.1 * idx) }}
                                    initial={START_ANIMATION_PROPERTY}
                                    whileInView={END_ANIMATION_PROPERTY}
                                    viewport={VIEWPORT_PROPERTY} >
                                    {item}
                                  </motion.p>
                                ))
                            }
                          </div>

                          <div className='flex flex-col gap-2 tablet:px-11 tablet:pb-[15vh]'>
                            {
                              item.list.map((item, idx) => (
                                <motion.p
                                  className='text-[#9E9E9E] tablet:text-xs'
                                  key={idx}
                                  transition={{ delay: (0.2 + 0.1 * idx) }}
                                  initial={START_ANIMATION_PROPERTY}
                                  whileInView={END_ANIMATION_PROPERTY}
                                  viewport={VIEWPORT_PROPERTY} >
                                  {item}
                                </motion.p>
                              ))
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </Fragment>
                }
              </FullpageSection>
            ))
          }
        </FullpageContainer>
      </section >
    </>
  )
}

export default Experience
